<template>
  <div class="mt-6">
    <UpgradeBanner v-if="currentUser && !currentUser.upgraded" />
    <div>
      <h1 class="title is-1">{{ $t("import-league") }}</h1>
    </div>
    <p>{{ $t("upload-a-diamond-scheduler-desktop-json-export-file") }}</p>
    <br />
    <div v-if="busy">
      <ProgressSpinner />
    </div>
    <div v-else>
      <uppy :max-file-size-in-bytes="1000000000" @complete="finished" :accepted="['application/json']"></uppy>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  data() {
    return {
      value: 1,
      value2: 1,
      busy: false,
    };
  },
  methods: {
    finished: function(url) {
      this.busy = true;
      console.log();
      console.log("Done!", url);
      api
        .importLeague(url)
        .then(response => {
          console.log(response);
          this.trackEvent("Imported League from JSON", { url: url });
          this.makeToast("success", this.$t("imported-league"));
          this.setCurrentLeagueSeasonId(response.data.league.id, response.data.season.id);
          this.goRouter("/");
          // this.refreshLeagueInformation("/");
        })
        .catch(error => {
          this.trackEvent("Imported League Fail", {
            url: url,
            errors: error,
          });
          console.log(error);
        })
        .finally(() => {
          this.busy = false;
        });
    },
  },
  created() {},
  mounted() {
    window.analytics.page();
  },
};
</script>

<style scoped lang="scss"></style>
